import React, { useState, useEffect } from 'react'
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { usePageTitle } from '../PageTitleContext';
import { useSelector } from 'react-redux';
import PublishAssets from './PublishAssets';
import UnPublishAssets from './UnPublishAssets';

const AssetsDashboard = () => {
    const { setPageTitle } = usePageTitle();
    const [activeKey, setActiveKey] = useState("published");

    const handleSelect = (key) => {
        setActiveKey(key);
      };

    useEffect(() => {
        setPageTitle("3D Assets");
    }, []);

    return (
        <>
            <div className='filterhere'>
                <Tabs activeKey={activeKey} onSelect={handleSelect}>
                    <Tab eventKey="published" title="Published" />
                    {/* <Tab eventKey="unpublished" title="Unpublished" /> */}
                </Tabs>
            </div>

           {activeKey === "published" && <PublishAssets />}
           {activeKey === "unpublished" && <UnPublishAssets />}
       
        </>
    )
}

export default AssetsDashboard;